import { SalaryStatus } from './types';

export const getStatusBadgeVariant = (status: string) => {
  switch (status) {
    case SalaryStatus.ACTIVE:
    case 'Aktiv': // TODO: remove when SF language issue is fixed
      return 'success';
    case SalaryStatus.UPCOMING:
      return 'warning';
    case SalaryStatus.EXPIRED:
      return 'secondary';
    default:
      return 'secondary';
  }
};
